import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SysAdminService } from "../services/sysadmin.service";
import { UserResetPasswordRequest } from "../services/UserResetPasswordRequest";
import { PasswordResetEmailComponent } from "./password-reset-email/password-reset-email.component";
import { UserModifyComponent } from "./user-modify/user-modify.component";
import { MfaToggleComponent } from "./mfa-toggle/mfa-toggle.component";

@Component({
	selector: "app-user-administration",
	templateUrl: "./user-administration.component.html",
	styleUrls: ["./user-administration.component.css"],
})
export class UserAdministrationComponent implements OnInit {
	constructor(
		private confirmationService: ConfirmationService,
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private sysAdminService: SysAdminService,
		private dialogService: DialogService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadPreferences();

		//Get Data from DB
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;

			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	user: any;

	SchoolID: any = 0;
	lstSchool: any = [];
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	DisableAddUser: boolean = true;
	DisableEditUser: boolean = true;
	DeleteUserMode: number = 0;

	SelectedUser: any;
	lstUsers: any = [];

	lstOriginalSchoolName: any = [];
	lstHomeSchoolDesc: any = [];
	lstUserLevelDesc: any = [];
	lstPersonDefinedByDesc: any = [];
	lstStatusDesc: any = [];
	lstAccountLocked: any = [];
	lstHighestRoleDesc: any = [];
	lstMFARegisteredDesc: any = [];
	lstMFAEnabledDesc: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	ToggleText: any = "Deactivate User";
	errorMessage: any = "";

	PreferenceLoading: boolean = false;
	loading: any = false;

	ShowColumns: any = {
		// UserName: true, //Can't turn off
		PersonName: true,
		OriginalSchool: false,
		HomeSchool: false,
		UserLevelDesc: true,
		Email: true,
		HighestRoleDesc: true,
		HighestRoleItemCount: false,
		SBMRoleDesc: false,
		StatusDesc: true,
		AccountLocked: true,
		LockDetails: false,
		LockDT: false,
		LastLoginDT: false,
		c_date: false,
		MFAEnabledDesc: false,
		MFARegisteredDesc: false,
	};

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				//Load users
				this.loadUsers();
			},
			(error) => {}
		);
	}

	loadPreferences() {
		this.PreferenceLoading = true;

		var result = this.sysAdminService.UserAdminPreferenceSelect();
		result.subscribe(
			(response: any) => {
				this.DisableAddUser = response.DisableAddUser;
				this.DisableEditUser = response.DisableEditUser;
				this.DeleteUserMode = response.DeleteUserMode;

				this.PreferenceLoading = false;
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	loadUsers() {
		if (this.SchoolID == undefined) {
			return;
		}

		this.loading = true;

		var result = this.sysAdminService.UserGetList(this.SchoolID, 2);
		result.subscribe(
			(response) => {
				// this.RawUserData = response;

				// this.UpdateTableData();

				this.lstUsers = response;

				this.lstOriginalSchoolName = Array.from(new Set(this.lstUsers.map((item: any) => item.OriginalSchoolName))).sort();
				this.lstHomeSchoolDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.HomeSchoolDesc))).sort();
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc))).sort();
				this.lstPersonDefinedByDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonDefinedByDesc))).sort();
				this.lstStatusDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.StatusDesc))).sort();
				this.lstAccountLocked = Array.from(new Set(this.lstUsers.map((item: any) => item.AccountLocked))).sort();
				this.lstHighestRoleDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.HighestRoleDesc))).sort();
				this.lstMFAEnabledDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.MFAEnabledDesc))).sort();
				this.lstMFARegisteredDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.MFARegisteredDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onRefresh() {
		this.errorMessage = "";

		this.loadUsers();
		// this.onRowUnselect(null);
	}

	onAddUser() {
		this.errorMessage = "";

		var ref = this.dialogService.open(UserModifyComponent, {
			header: "Add User",
			width: "fit-content",
			data: {
				EditMode: false,
				UserID: -1,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response: any) => {
			if (response == 1) {
				this.loadUsers();
				this.onRowUnselect(null);
			}
		});
	}

	onEditUser() {
		this.errorMessage = "";

		if (this.SelectedUser == null) {
			this.errorMessage = "Select a user to edit";
			return;
		}

		if (this.SelectedUser.UserID == this.user.userID) {
			this.errorMessage = "You cannot edit your own account";
			return;
		}

		//
		// UserLevel 1 = District
		// UserLevel 3 = School
		//
		// Defined By 3 = School
		// Defined By 4 = District
		//
		if (this.SelectedUser.UserLevelDesc == "District Level" && this.user.UserLevelID == 3) {
			this.errorMessage = "You cannot edit district users as a school user";
			return;
		}

		if (this.SelectedUser.UserID == 0) {
			this.errorMessage = "You cannot edit the Super User account";
			return;
		}

		var ref = this.dialogService.open(UserModifyComponent, {
			header: "Edit User",
			width: "fit-content",
			data: {
				EditMode: true,
				UserID: this.SelectedUser.UserID,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadUsers();
				this.onRowUnselect(null);
			}
		});
	}

	onRowDblClick(user) {
		this.SelectedUser = user;
		this.onEditUser();
	}

	onToggleUser() {
		this.errorMessage = "";

		if (this.SelectedUser == null) {
			this.errorMessage = "Select a user to toggle";
			return;
		}

		if (this.SelectedUser.UserID == this.user.userID) {
			this.errorMessage = "You cannot deactivate your own account";
			return;
		}

		if (this.SelectedUser.UserLevelID < this.user.UserLevelID) {
			this.errorMessage = "You cannot deactivate district users as a school user";
			return;
		}

		if (this.SelectedUser.UserID == 0) {
			this.errorMessage = "You cannot deactivate the Super User account";
			return;
		}

		// console.log("User to toggle");
		// console.log(this.SelectedUser);

		var changeTo = Number(this.SelectedUser.AccountActive) == 1 ? 0 : 1; //If active make inactive

		//Warning if person is inactive
		if (changeTo == 1 && Number(this.SelectedUser.PersonActive) == 0) {
			this.ConfirmActivate();
		} else {
			this.FinishActivate(changeTo);
		}
	}

	ConfirmActivate() {
		var MSG = "";

		MSG += "Reactivating this account (" + this.SelectedUser.UserName + ") will also reactivate the person (" + this.SelectedUser.PersonName + ").";
		MSG += " Do you want to continue?";

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Activate",
			icon: "fa",
			accept: () => {
				this.FinishActivate(1);
			},
			reject: () => {
				this.FinishActivate(1);
			},
		});
	}

	FinishActivate(changeTo) {
		var result = this.sysAdminService.UsersSetActive(this.SelectedUser.UserID, changeTo);
		result.subscribe(
			(response) => {
				this.loadUsers();
				// this.SelectedUser = null;
				// this.ToggleText = "Deactivate User";
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}

	onDeleteUser() {
		this.errorMessage = "";

		if (this.SelectedUser == null) {
			this.errorMessage = "Select a user to delete";
			return;
		}

		if (this.SelectedUser.UserID == this.user.userID) {
			this.errorMessage = "You cannot delete your own account";
			return;
		}

		if (this.SelectedUser.UserLevelID < this.user.UserLevelID) {
			this.errorMessage = "You cannot delete district users as a school user";
			return;
		}

		if (this.SelectedUser.UserID == 0) {
			this.errorMessage = "You cannot delete the Super User account";
			return;
		}

		this.confirmationService.confirm({
			key: "confirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to delete the user: " + this.SelectedUser.UserName + ". This CANNOT be UNDONE. Do you want to continue?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		var result = this.sysAdminService.UsersDelete(this.SelectedUser.UserID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
							this.onRowUnselect(null);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the user: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdateLock(uID, Locked) {
		this.errorMessage = "";

		if (uID == this.user.userID) {
			this.errorMessage = "You cannot lock or unlock your own account";
			return;
		}

		var LockUser: any;
		for (var i = 0; i < this.lstUsers.length; i++) {
			var next = this.lstUsers[i];
			if (next.UserID == uID) {
				LockUser = next;
				break;
			}
		}

		if (LockUser.UserLevelDesc == "District Level" && this.user.UserLevelID == 3) {
			this.errorMessage = "You cannot edit district users as a school user";
			return;
		}

		if (uID == 0) {
			this.errorMessage = "You cannot edit the Super User account";
			return;
		}

		var LockedInt = Locked == "Unlocked" ? 1 : 0; //If unlocked set to locked

		var result = this.sysAdminService.UsersSetLocked(uID, LockedInt, this.user.personID);
		result.subscribe(
			(response) => {
				this.loadUsers();
				this.SelectedUser = null;
			},
			(error) => {}
		);
	}

	onResetMFARegistration(User) {
		var MSG = "";

		MSG +=
			"You are about to reset the Multi-Factor Authenatication for " +
			User.UserName +
			". They will have to scan a QR code and re-register next time they login.";
		MSG += " Do you want to continue?";

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Reset MFA",
			icon: "fa",
			accept: () => {
				this.FinishMFAReset(User.UserID);
			},
			reject: () => {
				return;
			},
		});
	}

	FinishMFAReset(UserID) {
		var result = this.sysAdminService.UserResetMFA(UserID);
		result.subscribe(
			(response) => {
				this.loadUsers();
				this.SelectedUser = null;
			},
			(error) => {}
		);
	}

	onResetPassword() {
		this.errorMessage = "";

		if (this.SelectedUser == undefined) {
			this.errorMessage = "Select a user to send them a reset password email";
			return;
		}

		if (this.SelectedUser.UserLevelID < this.user.UserLevelID) {
			this.errorMessage = "You cannot send password reset emails to district users as a school user";
			return;
		}

		if (this.SelectedUser.UserID == 0) {
			this.errorMessage = "You cannot delete the Super User account";
			return;
		}

		if (this.SelectedUser.Email == null || String(this.SelectedUser.Email).trim() == "") {
			// this.errorMessage = "User does not have an email on record. Cannot Send them a reset password email.";
			// return;

			//
			// Let Sysadmin type in email?
			//
			var ref = this.dialogService.open(PasswordResetEmailComponent, {
				header: "Password Reset",
				width: "fit-content",
				data: {
					Username: this.SelectedUser.UserName,
					Email: this.SelectedUser.Email,
				},
			});
			ref.onClose.subscribe((response: any) => {
				if (response.Send != undefined && response.Send == true) {
					this.FinishResetPassword(this.SelectedUser.UserID, 1, response.Email);
				}
			});
		} else {
			this.FinishResetPassword(this.SelectedUser.UserID, 0, this.SelectedUser.Email);
		}
	}

	FinishResetPassword(UserID, UpdateEmail, Email) {
		var parms: UserResetPasswordRequest = {
			UserID: UserID,
			UpdateEmail: UpdateEmail,
			Email: Email,
		};

		var result = this.sysAdminService.UserResetPassword(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Password Reset Email was sent to " + parms.Email + ". The user will receive a link to enter a new password.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Send Password Reset Email",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleMFAUser(val) {
		this.SelectedUser = val;
		this.onToggleMFA();
	}

	onToggleMFA() {
		this.errorMessage = "";

		if (this.SelectedUser == null) {
			this.errorMessage = "Select a user to toggle whether they have MFA turned on or not";
			return;
		}

		if (this.SelectedUser.UserID == this.user.userID) {
			this.errorMessage = "NOTE: You can also update your account's MFA Settings by pressing the gear icon next to Log Out";
		}

		if (this.SelectedUser.UserLevelID < this.user.UserLevelID) {
			this.errorMessage = "You cannot toggle MFA Settings for district users as a school user";
			return;
		}

		if (this.SelectedUser.UserID == 0) {
			this.errorMessage = "You cannot turn on MFA for the Super User account";
			return;
		}

		if (this.SelectedUser.MFARegistered == true) {
			//Confirm Dialog
			this.confirmationService.confirm({
				key: "mfa",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: "Do you want to reset their MFA Registration? This will give them a new QR code next time they log in",
				header: "Reset MFA Registration",
				icon: "fa",
				accept: () => {
					this.FinishToggleMFA(true);
				},
				reject: () => {
					this.FinishToggleMFA(false);
				},
			});
		} else {
			this.FinishToggleMFA(false);
		}
	}

	FinishToggleMFA(reset) {
		var changeTo = this.SelectedUser.MFAEnabled == true ? 0 : 1;

		var result = this.sysAdminService.UsersToggleMFA(this.SelectedUser.UserID, changeTo, reset == true ? 1 : 0);
		result.subscribe(
			(response) => {
				this.loadUsers();
				// this.SelectedUser = null;
				this.onRowUnselect(null);
			},
			(error) => {
				//Fail Dialog
				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not " + (changeTo == 0 ? "Deactivate" : "Activate") + " MFA",
					header: "ERROR",
					icon: "fa",
					accept: () => {},
				});
			}
		);
	}

	onToggleAllMFA() {
		this.errorMessage = "";

		var ref = this.dialogService.open(MfaToggleComponent, {
			header: "Update MFA Settings",
			width: "650px",
			data: {},
		});
		ref.onClose.subscribe((response: any) => {
			if (response == 1) {
				this.loadUsers();
				this.onRowUnselect(null);
			}
		});
	}

	onDebugUser() {
		// this.errorMessage = "";
		// if(this.SelectedUser == null){
		//   this.errorMessage = "Select a user to view extra information";
		//   return;
		// }
		// if(this.SelectedUser.UserID == 0){
		//   this.errorMessage = "There's no extra information for SU";
		//   return;
		// }
		// var ref = this.dialogService.open(DebugUserDialogComponent, {
		//   header: "Debug User Information",
		//   width: '650px',
		//   data: {
		//     SelectedUser: this.SelectedUser
		//   }
		// });
		// ref.onClose.subscribe((response: any) => {
		//   // if (response == 1)
		//   // {
		//   //   this.loadUsers();
		//   //   this.onRowUnselect(null);
		//   // }
		// });
	}

	onResetColOption() {
		this.ShowColumns.PersonName = true;
		this.ShowColumns.OriginalSchool = false;
		this.ShowColumns.HomeSchool = false;
		this.ShowColumns.UserLevelDesc = true;
		this.ShowColumns.Email = true;
		this.ShowColumns.HighestRoleDesc = true;
		this.ShowColumns.HighestRoleItemCount = false;
		this.ShowColumns.StatusDesc = true;
		this.ShowColumns.AccountLocked = true;
		this.ShowColumns.LockDetails = false;
		this.ShowColumns.LockDT = false;
		this.ShowColumns.LastLoginDT = false;
		this.ShowColumns.c_date = false;
		this.ShowColumns.MFAEnabledDesc = false;
		this.ShowColumns.MFARegisteredDesc = false;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.onRowUnselect(null);

		//Update data
		this.loadUsers();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedUser = val.data;

		this.ToggleText = "Deactivate User";

		if (this.SelectedUser.StatusDesc == "Inactive") {
			this.ToggleText = "Activate User";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.ToggleText = "Deactivate User";

		this.SelectedUser = null;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else if (this.user.userID == undefined) {
			return false;
		} else {
			if (this.user.userID == 0) {
				return true;
			} else {
				return false;
			}
		}
	}

	DeleteUserAllowed() {
		if (this.DeleteUserMode == undefined) {
			return false;
		} else if (this.DeleteUserMode == 0) {
			return false;
		} else if (this.DeleteUserMode == 1 && this.IsSU() == true) {
			return true;
		} else if (this.DeleteUserMode == 2) {
			return true;
		}
	}

	////////////////////////////////////////////
}
